import React, { useMemo } from 'react';

import Select from 'react-select';

const VersionerDocumentItemSelect = (props) => {
  const {
    thread,
    selectedItemId,
    callbacks: {
      setSelectedItemId: callbackOnSetSelectedItemId
    },
    helpers: {
      itemName: itemNameHelper
    }
  } = props;

  const onChangeItemOptions = (e) => {
    const selectedItem = _.find(thread?.items, { id: e?.value });

    if (selectedItem && _.isFunction(callbackOnSetSelectedItemId)) {
      callbackOnSetSelectedItemId(selectedItem?.id);
    }
  };

  const itemSelectOptions =  useMemo(() => {
    return _.map(thread.items, (item) => {
      return {
        label: itemNameHelper(item),
        value: item.id
      }
    })
  }, [thread?.items])

  const itemSelectedOption = useMemo(() => {
    return _.find(itemSelectOptions, { value: selectedItemId }) || null
  }, [selectedItemId])

  return (
    <Select
      styles={{
        // Fixes the overlapping problem of the component
        menu: provided => ({ ...provided, zIndex: 9999 })
      }}
      value={itemSelectedOption}
      onChange={ (e) => onChangeItemOptions(e) }
      options={itemSelectOptions}
    />
  );
};

export default VersionerDocumentItemSelect;
